import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### メッセージ送信の返信 API 操作クラス
 */
export default class OtherUserGroupSendMessageRepliesMembers {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * Patch OtherUserGroupSendMessageRepliesMembers
   */
  public async patch(
    userStore: LoginUser,
    datetime: number,
    groupId: number,
    memberId: number,
    replyDatetime: number,
    sendMessageRepliesFamily: SendMessageRepliesMemberPatchModel
  ): Promise<SendMessageRepliesMemberPatchModel> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      datetime: datetime,
      groupId: groupId,
      memberId: memberId,
      replyDatetime: replyDatetime
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserGroupSendMessageRepliesMembers, formatParams);
    const response = await this.commonService.executePatch<SendMessageRepliesMemberPatchModel>(
      userStore,
      requestUrl,
      sendMessageRepliesFamily,
      this.constructor.name,
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }
}

/**
 * ### メッセージ送信の返信
 */
export interface SendMessageRepliesMemberPatchModel {
  /** 返信既読したユーザーID */
  readUserId: string;
  /** 返信既読したユーザー名 */
  readUserName: string;
  /** 既読／未読 */
  read: boolean;
  /** メッセージ内容 */
  message?: string;
  /** グループ名 */
  groupName?: string;
  /** グループ種類ID */
  groupTypeId?: number;
  /** グループメンバー名 */
  groupMemberName?: string;
  /** グループメンバー電話番号 */
  groupMemberTel?: string;
  /** グループメンバー所属 */
  groupMemberOrganization?: string;
}
